function createMarker(point, html, stcIcon, blnDisableLocationInfoWindow) {
	var marker = new google.maps.marker.AdvancedMarkerElement({
		position: point,
		icon: stcIcon
	});

	google.maps.event.addListener(marker, 'click', (function(markerArg) {
		return function() {
			objInfoWindow.setContent(html);
			objInfoWindow.setOptions({
				pixelOffset: new google.maps.Size(0, 1)
			});

			if ( blnDisableLocationInfoWindow == 'NO' || blnDisableLocationInfoWindow == 'false' ) {
				objInfoWindow.open(map, markerArg);
			}
		};
	})(marker));

	return marker;
}

// This function will create a google marker based on the color provided.
function createLocationMarker(strColor) {
	return new PinElement( {
		background: strColor,
	} );
}

async function mapMarkers() {
	aryLocations.forEach( async location => {
		const intMatchedSelectedLocationTypes = countMatchedLocationTypes(location);
		const blnIsMarkerOnMap = isLocationOnMap(location.LocationID);
		const strIcon = getIconToUse(location)

		let addMarker = false

		// If the current location is associated with one or more of the selected location types
		if (intMatchedSelectedLocationTypes >= 1) {
			// if the marker is already on the map, remove it and recreate it with a generic icon
			if (blnIsMarkerOnMap) {
				removeLocationMarker(location.LocationID);
			}

			addMarker = true
		}
		else {
			// If the current location is not associated with any of the selected location types and its marker
			if (blnIsMarkerOnMap) {
				removeLocationMarker(location.LocationID);
			}

			// If the current location is not associated with any location type and there is no location
			// type selected, add a marker with a generic icon for this location
			if (
				location.LocationTypes.length == 0
				|| (
					location.LocationTypes.length == 0
					&& arySelectedLocationTypes.length == 0
				)
			) {
				addMarker = true
			}
		}

		if ( addMarker ) {
			let marker = await addLocationMarker(location, strIcon, !blnGroupClusteredMarkers)
			aryMappedLocations.push( marker )
		}
	} )

	return Promise.resolve()
}

function extendBounds() {
	var objBounds = new google.maps.LatLngBounds();

	aryMappedLocations.forEach( location => {
		objBounds.extend(location.LocationPosition)
	} )

	if (!objBounds.isEmpty()) {
		map.fitBounds(objBounds);

		if (map.getZoom() > 13) {
			map.setZoom(13);
		}
	}

	return Promise.resolve()
}

// This function will prepare the arry of markers that will be displayed on/removed from the map
async function filterMarkers() {
	// First, hide all markers that are already on the map
	hideMarkers();

	mapMarkers()
		.then( extendBounds )
		.then( () => {
			if ( blnGroupClusteredMarkers ) {
				if ( objMarkerClusterer ) {
					objMarkerClusterer.clearMarkers()
				}

				const locationMarkers = aryMappedLocations.map( location => location.Marker )

				objMarkerClusterer = new markerClusterer.MarkerClusterer( {
					markers: locationMarkers,
					map: map,
					renderer: {
						render: ( { markers, _position: position } ) => {
							const count = markers.length;
							const label = String( count );
							let content;

							if ( clusterOptions.styles != undefined && clusterOptions.styles.length > 0 ) {
								// We have local styles and urls to use
								content = document.createElement("div");

								let index = label.length - 1;
								// make sure index is not higher than length of styles array
								if ( index > clusterOptions.styles.length - 1 ) {
									index = clusterOptions.styles.length - 1;
								}

								// set styles
								let src = clusterOptions.styles[index].url;
								content.setAttribute(
									"style",
									`color: ${clusterOptions.styles[index].textColor}; background-image: url(${src}); background-position: 0px 0px; background-size: 100%; width: ${clusterOptions.styles[index].width}px; line-height: ${clusterOptions.styles[index].height}px; height: ${clusterOptions.styles[index].height}px; text-align: center; position: relative;`
								);
								content.innerHTML = label;
							}
							else {
								// A marker with a custom inline SVG.
								const color = clusterOptions.icon.color;
								const parser = new DOMParser();
								const pinSvgString = `
									<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" width="${clusterOptions.icon.size}" height="${clusterOptions.icon.size}" viewBox="0 0 240 240"><circle cx="120" cy="120" opacity=".6" r="70" /><circle cx="120" cy="120" opacity=".3" r="90" /><circle cx="120" cy="120" opacity=".2" r="110" /><circle cx="120" cy="120" opacity=".1" r="130" /><text  x="50%" y="50%" fill="${clusterOptions.label.color}" font-size="${clusterOptions.label.fontSize}" dominant-baseline="middle" text-anchor="middle">${label}</text></svg>
								`;

								content = parser.parseFromString(
									pinSvgString,
									"image/svg+xml",
								).documentElement;
							}

							// create marker using content
							return new google.maps.marker.AdvancedMarkerElement( {
								position,
								content: content,
								zIndex: 1000 + count,
							} )
						},
					},
				} )
			}
		} )
}

// Check the selected location type and filter markers
function filterByLocationType(intID,typeName) {
	showHideLocationType(intID,typeName);
	filterMarkers();
}

// Check/uncheck the selected location type and add or remove it from arySelectedLocationTypes
function showHideLocationType(intID,typeName) {
	var intFound = -1;
	for (var i=0; i < arySelectedLocationTypes.length; i++) {
		if (arySelectedLocationTypes[i] == intID) {
			intFound = i;
			break;
		}
	}
	if (intFound != -1) {
		arySelectedLocationTypes.splice(intFound,1);

		// Unselect the location type
		jQuery("#" + "LocationTypeID_" + intID).removeClass("selected");
		jQuery("#" + "LocationTypeID_" + intID).prop('title', 'Show ' + typeName);

		if (jQuery("#SelectAll").prop("checked")) {
			jQuery("#SelectAll").prop("checked", null);
		}
	}
	else {
		var blnFound = false;
		for (var m=0; m < arySelectedLocationTypes.length; m++) {
			if (arySelectedLocationTypes[m] == intID) {
				blnFound = true;
				break;
			}
		}
		if (!blnFound) {
			arySelectedLocationTypes.push(intID);
		}

		// Select the location type
		jQuery("#" + "LocationTypeID_" + intID).addClass("selected");
		jQuery("#" + "LocationTypeID_" + intID).prop('title', 'Hide ' + typeName);
	}
	// If all location types are selected, check the Select All check box
	if (arySelectedLocationTypes.length == aryLocationTypes.length) {
		jQuery("#SelectAll").prop("checked","checked");
	}
	else {
		jQuery("#SelectAll").prop("checked", null);
	}
}

// Sets the content of the popup window when clicking on the map location marker
function getPopupWindowContent(location) {
	var strCurrentInfoWindowContent = '' +
		'<div id="popupWindow">' +
		'<div class="location-info-pop-up">' +
			'<div class="location-info-pop-up-row"><a class="infoTitle" href="' + location.LocationPath + '">' + location.LocationHtmlName + '</a></div>' +
			'<div class="location-info-pop-up-row location-info-pop-up-image-name location-info-pop-up-row-padding">';

	if (location.LocationImage != '') {
		strCurrentInfoWindowContent += '' +
				'<div class="location-info-pop-up-image" style="' + location.LocationImageWidth + '#">' +
					'<a href="' + location.LocationPath + '">' +
						'<img src="' + location.LocationImage + '" alt="Location Image" title="' + location.LocationHtmlName + '" border="0" />' +
					'</a>' +
				'</div>' +
				'<div class="location-info-pop-up-name infoAddress" style="padding-left:8px;">';
	}
	else {
		strCurrentInfoWindowContent += '<div class="location-info-pop-up-name infoAddress">';
	}

	strCurrentInfoWindowContent += '' +
					location.LocationHtmlAddress +
				'</div>' +
			'</div>';

	if (location.LocationDescription != '') {
		strCurrentInfoWindowContent += '' +
			'<div class="infoDescription location-info-pop-up-row location-info-pop-up-row-padding">' + location.LocationDescription + '</div>';
	}

	if (location.LocationPhone != '') {
		strCurrentInfoWindowContent += '' +
			'<div class="location-info-pop-up-row location-info-pop-up-row-padding"><span><a href="tel:' + location.LocationPhone + '">' + location.LocationPhone + '</a></span></div>';
	}

	strCurrentInfoWindowContent += '' +
			'<div class="location-info-pop-up-row location-info-pop-up-directions-read-more location-info-pop-up-row-padding">' +
					location.DirectionsLink +
					'&nbsp;|&nbsp;' +
					'<a class="infoLink" href="' + location.LocationPath + '">' + strReadMoreLocale + '</a>' +
			'</div>' +
		'</div>' +
	'</div>';

	return strCurrentInfoWindowContent
}

function colorLuminance(hex, lum) {
	hex = String(hex).replace(/[^0-9a-f]/gi, "");
	if (hex.length === 3) {
		hex = hex.replaceAll("#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])", "#$1$1$2$2$3$3");
	}

	// Darken a color with a negative value; lighten a color with a positive value
	lum = lum || 0;

	// convert to decimal and change luminosity
	var rgb = "#", c, i;

	for (i = 0; i < 3; i++) {
		c = parseInt(hex.substr(i*2,2), 16);
		c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
		rgb += ("00"+c).substr(c.length);
	}

	return rgb;
}

// Add a Location marker to the map
async function addLocationMarker(location, strIcon, addToMap) {
	const { PinElement, AdvancedMarkerElement } = await google.maps.importLibrary("marker");
	let content

	if ( strIcon.search("^([0-9a-fA-F]){6}$") >= 0 ) {
		const strDarkerColor = colorLuminance(`#${ strIcon }`, -0.3)

		const pinBackground = new PinElement( {
			background: `#${ strIcon }`,
			borderColor: strDarkerColor,
			glyphColor: strDarkerColor,
		} );

		content = pinBackground.element
	}
	else {
		content = document.createElement("img")
		content.src = strIcon
		content.width = 24
		content.height = 24
	}

	const stcMarkerOptions = {
		position: location.LocationPosition,
		content: content,
		title: location.LocationName,
	}

	if ( addToMap ) {
		stcMarkerOptions.map = map
	}

	const marker = new AdvancedMarkerElement( stcMarkerOptions )

	if (location.LocationID != "" ) {
		marker.addListener( "click", () => {
			if ( blnDisableLocationInfoWindow ) {
				window.location.href = location.LocationPath;
			}
			else {
				const strInfoWindowContent = getPopupWindowContent(location)

				objInfoWindow.setContent(strInfoWindowContent)
				objInfoWindow.open(map, marker)
			}
		} )
	}

	return {
		LocationID: location.LocationID,
		LocationPosition: location.LocationPosition,
		Marker: marker,
	}
}

// Remove a Location marker from the map
function removeLocationMarker(intLocationID) {
	for (var i=0; i < aryMappedLocations.length; i++) {
		if (aryMappedLocations[i].LocationID == intLocationID) {
			aryMappedLocations[i].Marker.setMap(null);
			aryMappedLocations.splice(i,1);
		}
	}

	return;
}

// Determine if the given location has a marker on the map
function isLocationOnMap(intLocationID) {
	return aryMappedLocations
		.filter( item => item.LocationID === intLocationID )
		.length > 0
}

// Returns the number of selected location types associated with the current locationID
function countMatchedLocationTypes(location) {
	let intMatchedLocationTypes = 0;

	for (let i=0; i < arySelectedLocationTypes.length; i++) {
		for (let j=0; j < location.LocationTypes.length; j++) {
			if (arySelectedLocationTypes[i] == location.LocationTypes[j]) {
				intMatchedLocationTypes++;
			}
		}
	}

	return intMatchedLocationTypes;
}

// Returns the icon to use based on the location types selected
function getIconToUse(location) {
	for (var i=0; i < arySelectedLocationTypes.length; i++) {
		for (var j=0; j < location.LocationTypes.length; j++) {
			if (arySelectedLocationTypes[i] == location.LocationTypes[j]) {
				for (var k=0; k < aryLocationTypes.length; k++) {
					if (aryLocationTypes[k].LocationTypeID == arySelectedLocationTypes[i]) {
						if (aryLocationTypes[k].LocationTypeImage != "") {
							return aryLocationTypes[k].LocationTypeImage;
						}

						if (aryLocationTypes[k].LocationTypeColor != "") {
							return aryLocationTypes[k].LocationTypeColor;
						}
					}
				}
			}
		}
	}
	if (location.LocationID == "") {
		return "969696";
	}

	return strGenericIconColor;
}

// Hide all markers
function hideMarkers() {
	for (var i=0; i < aryMappedLocations.length; i++) {
		aryMappedLocations[i].Marker.setMap(null);
	}
	objInfoWindow.close();
}

// Toggles all the locations on the map
function showHideAllLocationTypes() {
	if (jQuery("#SelectAll").prop("checked")) {
		// Select all location types
		jQuery(".type_item").addClass("selected");

		// Select all location types
		let blnFound = false;

		aryLocationTypes.forEach( locationType => {
			for (let j=0; j < arySelectedLocationTypes.length; j++) {
				if (arySelectedLocationTypes[j] == locationType.LocationTypeID) {
					blnFound = true;
					break;
				}
			}

			if (!blnFound) {
				arySelectedLocationTypes.push(locationType.LocationTypeID);
			}

			blnFound = false;
		} )

		filterMarkers();
	}
	else {
		// Unselect all location types
		jQuery(".type_item").removeClass("selected");

		hideMarkers();

		arySelectedLocationTypes = [];

		if (typeof objMarkerClusterer != "undefined") {
			objMarkerClusterer.clearMarkers();
		}
	}

	if (jQuery('#SelectAll').length == 0) {
		filterMarkers();
	}
}

function validate(frm, callback, fncErrorDisplay) {
	var strMessages = "";
	var objFocusField;

	// Define a default way to display validation errors
	if (!fncErrorDisplay) {
		fncErrorDisplay = displayValidationErrors;
	}

	// Create field/error lists
	var aryFieldList = ["rz_PostalCode"];
	var aryErrorList = ["'Zip Code' is required and must be a valid Zip Code."];
	var stcMessages = {};

	// Are field/error lists the same length?
	if (aryFieldList.length != aryErrorList.length) {
		alert("Validation and error message lists must be the same length!");

		return false;
	}

	// Validate each field
	for (var ctrField = 0;ctrField < aryFieldList.length;ctrField++) {
		// Separate validations and field
		var strValidations = aryFieldList[ctrField].split("_")[0];
		var strFieldName = aryFieldList[ctrField].split("_")[1];
		var strFieldError = aryErrorList[ctrField];

		// Validate each validation
		for (var ctrValidation = 0;ctrValidation < strValidations.length;ctrValidation++) {
			var strValidation = strValidations.substr(ctrValidation,1);
			var intErrorCount = 0;
			switch (strValidation) {
				case 'r':
					intErrorCount += r(frm,strFieldName,strValidations);
					break;
				case 'z':
					intErrorCount += z(frm,strFieldName,strValidations);
					break;
				default:
					alert("No validation for '" + strValidation + "'!");
					break;
			}

			// Set the error message
			if (intErrorCount > 0) {
				stcMessages[strFieldName] = strFieldError;
			}

			// Set the focus field after first error
			if (strMessages != "" && !objFocusField) {
				if (eval("frm." + strFieldName)) {
					var objField = eval("frm." + strFieldName);
					if (objField.focus) {
						objFocusField = objField;
					}
				}
			}
		}
	}

	// If a callback was provided, call it now
	if (callback) {
		stcMessages = callback(stcMessages, frm);
	}

	// Display the error messages in some manner
	fncErrorDisplay(stcMessages);

	// If there's nothing in stcMessages, validation has passed
	var intErrors = 0;
	for (key in stcMessages) {
		if (stcMessages.hasOwnProperty(key)) {
			intErrors++;
		}
	}

	return intErrors == 0;
}

function displayValidationErrors(stcMessages) {
	var strMessages = "";
	for (fieldName in stcMessages) {
		strMessages += stcMessages[fieldName] + "\n";
	}

	if (strMessages.length) {
		alert("Please review the following:\n\n" + strMessages);
	}
}

function r(frm,field,validations) {
	var intErrors = 0;

	// "Normal" Validation
	if (validations.search("f") < 0 && validations.search("a") < 0 && eval("frm." + field)) {
		var objField = eval("frm." + field);

		// Any element of tag input and textarea
		if (objField.tagName.toLowerCase() == "input" || objField.tagName.toLowerCase() == "textarea") {
			intErrors = (objField.value == "") ? 1 : 0;
		}
	}

	return intErrors;
}

function z(frm,field,validations) {
	var intErrors = 0;
	var objField = eval("frm." + field);
	var strREReqs = /^((\d{5,5})|(\d{5,5}\-\d{4,4})|(([A-Za-z]){1}\d{1}([A-Za-z]){1}\s\d{1}([A-Za-z]){1}\d{1})){1}$/;
	if (objField && objField.value && objField.value != "" && objField.value.search(strREReqs) == -1) {
		intErrors++;
	}

	return intErrors;
}
